var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.docs.name,"value":_vm.value,"items":_vm.docs.enumValues,"item-text":"label","item-value":"id","disabled":_vm.readonly},on:{"change":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }